
import {Component, Vue, Watch} from "vue-property-decorator";
import RfidMenuItem from "@/views/rfid/In/RfidMenuItem.vue";
import DataEmpty from "@/views/components/DataEmpty/DataEmpty.vue";
import RfidEditConfig from "@/views/rfid/RfidEditConfig";
import RfIdScanInfo from "@/views/rfid/RfIdScanInfo.vue";
import Scan from "@/views/components/Scan/Scan.vue";
import ScanInfoDetails from "@/views/rfid/ScanInfoDetails.vue";
import {parseTime, showLabel} from "@/utils";
import {HeapItem, ReturnMsg, ScanDataItem, TaskItem} from "@/views/rfid/TaskItem";
import ReconnectingWebSocket from 'reconnecting-websocket';
import Enumerable from "linq";
import RfidHeapSelect from "@/views/rfid/RfidHeapSelect.vue";
import dayjs from "dayjs";
import {RfidService} from "@/views/rfid/api/rfid-service";
import SupplierOrRepairFactoryDialog from "@/views/rfid/SupplierOrRepairFactoryDialog.vue";

@Component({
  name: "RfidLayout",
  components: {
    RfidHeapSelect,
    ScanInfoDetails,
    Scan,
    RfIdScanInfo,
    DataEmpty,
    RfidMenuItem,
    SupplierOrRepairFactoryDialog
  },
  filters: {
    showIssue(value) {
      if (value) {
        return '已发放'
      } else {
        return '未发放';
      }
    },
    showLabel: showLabel,
  }
})
export default class extends Vue {
  private isAddHeap: boolean = false;


  private rfidConfig = RfidEditConfig;
  private isDel = false;
  private showTaskList: boolean = true;
  private taskList: TaskItem[] = [];
  private currentTask: TaskItem = null;
  private items: ScanDataItem[] = [];
  private heapList: HeapItem[] = [];
  private DQSBLog: string = '';
  private msglog: string = '';
  private heapCount: number = 0;

  private scanType: string = '';
  private packageType: string = '';
  private taskId: string = '';
  private scanCount: number = null;
  private totalCount: number = null;
  private ip: string = "";
  private u_count: number = 0;
  private isLoading: boolean = false;
  private showTaskBtns: boolean = false;
  private showFixkBtn: boolean = false;
  private showHeapSelect: boolean = false;
  private selectHeapList: HeapItem[] = [];
  private selectedHeapList: HeapItem[] = [];
  private UploadPercentage: number = 0;
  private saveDbCount = {};
  private currentHeap: HeapItem = null;
  private actionList: string[] = [];
  private hasSupplierOrRepairFactory: boolean = false;
  private btn_form:any = {};
  //-1 错误，0 未开始，1开始，1.1 发送开始命令，未收到返回，2关闭，3上传，3.1发送上传，未收到返回，4停止上传，4.1发送停止上传，未收到返回
  private deviceStatus: number = 0;
  private uploadPerson = "";//装车人员
  private uploadPersonSelect = false;//装车人员选择对话框
  private repairPackageData = '';
  private selectedSupplier: any = {};
  private selectedRepairFactory: any = {};
  private dialogType = null;

  @Watch('btn_form.repairType', {immediate: true})
  private btnFromRepairTypeChange(val){
    this.sendAction({
      action: 'SetRepairType',
      data: val
    })
  }

  private setRepairPackageData(val) {
    this.repairPackageData = val?.trim();
  }

  get isShowDialog() {
    return !!this.dialogType;
  }

  set isShowDialog(v) {
    if (!v) {
      this.dialogType = null;
    }
  }

  get selectedSupplierOrRepairFactory() {
    return this.dialogType === 'supplier' ? this.selectedSupplier : this.selectedRepairFactory;
  }

  set selectedSupplierOrRepairFactory(v) {
    if (this.dialogType === 'supplier') {
      this.selectedSupplier = v;
    } else {
      this.selectedRepairFactory = v;
    }
  }

  get caijiBtnText() {
    if (this.isDel) {
      return "删除模式";
    }
    return "采集模式";
  }

  get menuDisabled() {
    return this.deviceStatus == 3 || this.deviceStatus == 3.1
  }

  get caijiBtnType() {
    if (this.isDel) {
      return "danger";
    }
    return "success";
  }

  private created(): void {
  }

  private mounted(): void {
    var date = new Date();
    var str = parseTime(date, '{y}-{m}-{d} {h}:{i}:{s}:{f}');
    console.log(date, str);
    this.init();
  }

  private scanTypeChange(e){
    console.log(e)
  }

  private async uploadClick() {
    if (!this.scanType) {
      this.$message.error('请先选择操作类型！')
      return false;
    }
    if (this.deviceStatus === 1) {
      this.$message.error('先暂停扫描！')
      return false;
    }
    if (!this.scanCount) {
      this.$message.error('暂无数据可上传！')
      return false;
    }
    if (this.currentTask && this.currentTask.TaskNum !== (this.scanCount + (this.currentTask.AlreadyOperatedNum || 0))) {
      await this.alert('扫描数量与申请数量不一致！', '提示')
      this.deviceStatus = 0;
      return;
    } else {
      if (this.currentTask?.LastUploadTime) {
        //没有最后一次的上传时间，不校验
        try {
          var timeDiff = dayjs().diff(dayjs(this.currentTask.LastUploadTime), 'h');
          if (timeDiff > 12) {
            var _this = this;
            var scan_info: any = _this.$refs['scan-info'];
            scan_info.closeLoading();
            await this.alert('需在12小时内完成补上传', '提示');
            this.deviceStatus = 0;
            return false;
          }
        } catch (error) {
          console.log("时间校验失败:跳过" + error);
        }
      }
    }
    if (!this.currentTask && !this.currentHeap) {
      try {
        await this.$confirm('当前操作没有选堆, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        this.deviceStatus = 3.1;
        if (this.currentTask && this.currentTask.Scan_Type == 22) {
          this.uploadPersonSelect = true;
          return false;
        } else {
          this.sendAction({
            action: 'StartUploadData',
            repairPackageData: this.repairPackageData
          })
          return true;
        }
      } catch (e) {
        return false;
      }

      return true;
    } else {
      this.deviceStatus = 3.1;
      if (this.currentTask && this.currentTask.Scan_Type == 22) {
        this.uploadPersonSelect = true;
        return false;
      } else {
        this.sendAction({
          action: 'StartUploadData',
          repairPackageData: this.repairPackageData
        })
        return true;
      }
    }
  }

  private alert(msg, title) {
    var _this = this;
    return new Promise<void>(function (resolve, reject) {
      _this.$alert(msg, title, {
        confirmButtonText: '确定',
        callback: action => {
          resolve()
        }
      });
    });
  }

  private showFormat(format, val) {
    return this[format](val);
  }

  private showScanType(row): string {
    return showLabel(row.Scan_Type + '', this.rfidConfig.allScanTypes, undefined, true);
  }

  private showPackageType(row): string {
    return showLabel(row.PACKAGE_TYPE + '', this.rfidConfig.allPackageTypes, undefined, true);
  }

  private showBusinessType(row): string {
    if (row.Scan_Type == 23) {
      return ''
    }
    return showLabel(row.BUSINESS_TYPE + '', this.rfidConfig.outboundTypes, undefined, true);
  }

  private initTaskList(): void {
    this.sendAction('initTaskList')
  }

  private handleSelect(index) {
    if (index === 'out') {
      this.showTaskList = true;
      this.initTaskList();
      return;
    }
    if (index === 'fixData') {
      if (!this.currentTask) {
        this.$message.error('入库袋子无法处理修复数据')
      } else {
        if (this.scanCount > this.currentTask.TaskNum) {
          this.sendAction('fixData');
        }
      }
      return;
    }
    if (/^\d+-\d+-\d+$/.test(index)) {
      this.items = [];
      this.showTaskList = false;
      var m = /^(\d+)-(\d+)-(\d+)$/.exec(index);
      var taskId = m[1];
      var scanType = m[2];
      var packageType = m[3];
      this.scanType = scanType;
      this.packageType = packageType;
      this.taskId = taskId;
      this.showTaskBtns = false;
      var obj = {
        action: 'SetScanType', value: {scanType: scanType, taskId: taskId, package: packageType}
      };
      this.currentTask = null;
      this.sendAction(obj);
    }
  }

  private ws = null;

  private clearHeap() {
    var scanInfoDetails: any = this.$refs.scanInfoDetails;
    scanInfoDetails.clearHeap();
  }

  private TaskReview(row: TaskItem): void {
    //2022-09-20 add
    if (row.AlreadyOperatedNumLocal >= row.TaskNum) {
      this.$alert('已完成上传', '提示', {
        confirmButtonText: '确定'
      });
      return;
    }
    if (this.currentTask == row) {
      return;
    }
    this.heapList = [];
    this.clearHeap();
    this.items = [];
    if (this.currentTask) {
      this.currentTask.Scan_Issue = false;
      this.currentTask.Scan_SelectCount = 0;
    }
    this.currentTask = row;
    this.scanType = row.Scan_Type.toString();
    this.packageType = row.PACKAGE_TYPE.toString();
    this.taskId = row.APPLY_ID.toString();
    var obj = {action: 'TaskReview', value: row};
    this.showTaskBtns = true;
    this.sendAction(obj);
  }

  private sendAction(action) {
    this.isLoading = true;
    if (typeof action === "string") {
      this.ws.send(JSON.stringify({action: action}))
    } else if (typeof action === "object") {
      this.ws.send(JSON.stringify(action))
    }
  }

  private init() {
    var _this = this;
    this.ws = new ReconnectingWebSocket('ws://localhost:41998', [], {debug: true});
    // this.ws = new WebSocket('ws://localhost:41998');
    this.ws.onopen = () => {
      console.log('WS 链接成功');
      this.sendAction('init');
      this.initTaskList();
    };
    this.ws.onmessage = (e) => {
      this.isLoading = false;
      var obj: ReturnMsg = JSON.parse(e.data);
      console.log(e.data)
      if (obj.success) {
        if (obj.action === "error") {
          this.$message.error(obj.message)
          return;
        }
        if (obj.action === "initTaskList") {
          _this.taskList = obj.data;
          return;
        }
        if (obj.action === "TaskReview") {
          if (obj.data && obj.data.length > 0) {
            if (obj.data[0].status === 1) {
              _this.showTaskBtns = true;
              _this.currentTask.Scan_Issue = true;
            }
          }
          if (obj.success) {
            _this.showTaskBtns = true;
            _this.currentTask.Scan_Issue = true;
          }
          return;
        }
        if (obj.action === "actionlist") {
          _this.actionList = obj.data;
          return;
        }
        if (obj.action === "LoadTempDataCount") {
          var task: TaskItem = Enumerable.from(_this.taskList).first(fx => fx.APPLY_ID === obj.data.taskId);
          if (task) {
            task.Scan_SelectCount = obj.data.count;
          }
          return;
        }
        if (obj.action === "setlist") {
          _this.items = obj.data.list;
          _this.scanCount = obj.data.total;
          _this.u_count = obj.data.heapCount;
          return;
        }
        if (obj.action === "SetDQSBLog") {
          _this.DQSBLog = obj.data.msg;
        }
        if (obj.action === "setmsg") {
          _this.msglog = obj.data.msg;
        }
        if (obj.action === "setip") {
          _this.ip = obj.data.ip;
        }
        if (obj.action === "StartEpc") {
          _this.deviceStatus = 1;
          _this.$notify.success(`设备：${_this.ip}链接成功`)
        }
        if (obj.action === "setheaplist") {
          var h = obj.data;
          if (h && h.length) {
            _this.heapList = h;
          } else {
            _this.heapList = []
          }
        }
        if (obj.action === "SetHeapNumber") {
          _this.u_count = obj.data.heapCount;
        }
        if (obj.action === "LoadHeapFormData") {
          _this.selectHeapList = obj.data.lis;
        }
        if (obj.action === "SetHeapCount") {
          _this.u_count = obj.data.count;
        }
        if (obj.action === "AbandonScanData") {
          _this.items = [];
          if (_this.currentTask) {
            _this.currentTask.Scan_Issue = false;
          }
          _this.scanCount = 0;
          _this.totalCount = undefined;
          _this.u_count = 0;
        }
        if (obj.action === "StartUploadData") {
          _this.deviceStatus = 3;
        }
        if (obj.action === "setGlobalScanCount") {
          _this.scanCount = obj.data;
        }
        if (obj.action === "SetUploadProgress") {
          _this.UploadPercentage = ((obj.data.current / obj.data.total) * 100);
          if (_this.UploadPercentage === 100 || obj.data.current == obj.data.total) {
            _this.deviceStatus = 0;
            _this.items = [];
            _this.heapList = [];
            _this.scanCount = 0;
          }
        }
        if (obj.action === "saveInDb") {
          _this.saveDbCount = obj.data;
        }
        if (obj.action === "StopEpc") {
          _this.deviceStatus = 0;
        }
        if (obj.action === "StartUploadDataEnd") {
          this.$alert('上传成功', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              try {
                // this.taskList = this.taskList.filter(element => element.APPLY_ID.toString() != this.taskId);
                this.initTaskList();
              } catch (error) {
                // console.log("去除列表中的数据异常:"+error);
                console.log("重新加载任务列表出错:" + error);
              }
              _this.deviceStatus = 0;
              _this.items = [];
              _this.heapList = [];
              _this.scanCount = 0;
              _this.currentTask = null;
              _this.scanType = undefined;
              _this.packageType = undefined;
              _this.taskId = undefined;
              _this.currentHeap = undefined;
              var rfidHeapComponent: any = _this.$refs['scanInfoDetails'];
              rfidHeapComponent.clearHeap();
              var scan_info: any = _this.$refs['scan-info'];
              scan_info.closeLoading()
            }
          });
        }
        if (obj.action === "ApiInfo") {
          RfidService.initialize(obj.data.baseUrl, obj.data.token)
        }
        if (obj.action === 'features') {
          this.hasSupplierOrRepairFactory = obj.data?.hasSupplierOrRepairFactory;
        }
        return;
      }
      console.log(e.data);
      if (obj.action === "StartEpc") {
        _this.deviceStatus = 0;
      }
      if (obj.action === "error_StartEpc") {
        this.$message.error(obj.message)
        this.deviceStatus = 0
        return;
      }
      if (obj.action === "StartUploadDataEnd") {
        _this.deviceStatus = 0;
        var scan_info: any = _this.$refs['scan-info'];
        scan_info.closeLoading()
      }
      if (obj.message) {
        _this.$message.error(obj.message);
      }
    };
  }

  uploadData() {
    var _this = this;
    if (this.uploadPerson === "") {
      this.$message.warning("请选择装车人员");
    } else {
      this.uploadPersonSelect = false;
      var scan_info: any = _this.$refs['scan-info'];
      scan_info.openLoading();
      var obj = {action: 'StartUploadData', uploadPerson: this.uploadPerson, repairPackageData: this.repairPackageData};
      this.sendAction(obj);
    }
    this.uploadPerson = "";
  }

  clearScanData() {
    this.items = [];
    if (this.currentTask) {
      this.currentTask.Scan_Issue = false;
    }
    this.scanType = '';
    this.packageType = '';
    this.taskId = '';
    this.scanCount = 0;
    this.totalCount = undefined;
    this.u_count = 0;
  }

  loadHeapDataToTask() {
    var rfidHeapComponent: any = this.$refs['rfid-heap-select'];
    var items: HeapItem[] = rfidHeapComponent.getSelectList();
    if (items.length) {
      var names = Enumerable.from(items).select(f => f.u_name).toArray();
    }
    this.sendAction({
      action: 'AddHeapDataToTask',
      value:
        {
          heapNames: names,
          isAddHeap: this.isAddHeap
        }
    });
    this.showHeapSelect = false
  }

  heapNumberChanged(item: HeapItem) {
    if (item) {
      this.currentHeap = item;
      this.u_count = 0;
      this.sendAction({
        action: 'SetHeapNumber', value: {
          heapInfo: item,
        }
      })
    } else {
      this.currentHeap = undefined;
      this.u_count = 0;
      this.sendAction("ClearHeap")
    }
  }

  @Watch('scanType')
  onScanTypeChanged(val) {
    if (!this.hasSupplierOrRepairFactory) {
      return;
    }
    if (val !== '12') {
      this.selectedSupplier = {};
    }
    if (val !== '48') {
      this.selectedRepairFactory = {};
    }
  }

  @Watch('selectedSupplier')
  onSelectSupplier() {
    this.sendAction({
      action: 'selectSupplier',
      value: this.selectedSupplier,
    })
  }

  @Watch('selectedRepairFactory')
  onSelectRepiarFactory() {
    this.sendAction({
      action: 'selectRepairFactory',
      value: this.selectedRepairFactory,
    })
  }

  showSupplierOrRepairFactoryDialog(dialogType) {
    this.dialogType = dialogType;
  }
}
